document.addEventListener('DOMContentLoaded', function() {
    const searchInput = document.querySelector('.country-search__input');
    const countryList = document.querySelector('.CountryList');
    const disclosureButton = document.querySelector('.disclosure__button');
    
    if (searchInput && countryList) {
      const originalOrder = Array.from(countryList.querySelectorAll('.disclosure__item'));
      let searchTimeout;
      
      searchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          return false;
        }
      });
      
      searchInput.addEventListener('input', function() {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
          const searchTerm = this.value.toLowerCase().trim();
          
          if (searchTerm === '') {
            originalOrder.forEach(item => countryList.appendChild(item));
            return;
          }
          
          const matchingCountries = [];
          const nonMatchingCountries = [];
          
          originalOrder.forEach(item => {
            const countryText = item.textContent.toLowerCase();
            if (countryText.includes(searchTerm)) {
              matchingCountries.push(item);
            } else {
              nonMatchingCountries.push(item);
            }
          });
          
          originalOrder.forEach(item => item.remove());
          
          matchingCountries.forEach(item => countryList.appendChild(item));
          
          nonMatchingCountries.forEach(item => countryList.appendChild(item));
        }, 150);
      });
    }
    
    if (disclosureButton) {
      document.addEventListener('click', function(e) {
        const disclosure = disclosureButton.closest('.disclosure');
        const isClickInside = disclosure && disclosure.contains(e.target);
        
        if (!isClickInside && countryList && !countryList.hidden) {
          countryList.hidden = true;
          disclosureButton.setAttribute('aria-expanded', 'false');
        }
      });
    }
});